import { z } from "zod";

export const BranchHoursFormSchema = z.object({
  schedules: z.array(
    z.object({
      day: z.string(),
      closed: z.boolean(),
      open: z.string(),
      close: z.string(),
    })
  ),
});

export type BranchHoursFormType = z.infer<typeof BranchHoursFormSchema>;
